"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SNL_NUMBERING = exports.DEFAULT_NUMBERING = void 0;
exports.DEFAULT_NUMBERING = {
    sceneHeading: 'manual',
    slug: 'manual',
    dialogue: 'manual',
    dual_dialogue: 'manual',
    bracket: 'manual',
};
exports.SNL_NUMBERING = {
    slug: 'auto',
    sceneHeading: 'auto',
    bracket: 'none',
    dialogue: 'none',
    dual_dialogue: 'none',
};
